export default __webpack_public_path__ + "static/media/ZZC_1110.7dbc4740.jpg";